import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=35bb1e12&scoped=true"
import script from "./TheFooter.js?vue&type=script&lang=js&external"
export * from "./TheFooter.js?vue&type=script&lang=js&external"
import style0 from "./TheFooter.scss?vue&type=style&index=0&id=35bb1e12&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb1e12",
  null
  
)

export default component.exports